import CloseIcon from '@mui/icons-material/Close';
import { Grid, IconButton, Typography } from '@mui/material';
import PropTypes from 'prop-types';

// Matches e-scribe-ui's Formulary dialogs (New Catalog / Edit Catalog / Edit
// Availability): a solid primary-colour bar with the title and a close X,
// rather than MUI's default DialogTitle.
const CatalogDialogHeader = ({ title, onClose }) => (
  <Grid
    container
    sx={{ bgcolor: 'primary.main', color: 'background.default', px: 3, py: 1.5 }}
    justifyContent='space-between'
    alignItems='center'
  >
    <Typography variant='h6' component='h2'>
      {title}
    </Typography>
    <IconButton aria-label='close' onClick={onClose} sx={{ color: 'background.default' }}>
      <CloseIcon />
    </IconButton>
  </Grid>
);

CatalogDialogHeader.propTypes = {
  title: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CatalogDialogHeader;
